const GET_SHOP_CITIES = "GET_SHOP_CITIES";
const GET_SHOP_CITIES_SUCCESS = "GET_SHOP_CITIES_SUCCESS";
const GET_SHOP_CITIES_FAILURE = "GET_SHOP_CITIES_FAILURE";
const CLEAR_SHOP_CITIES = "CLEAR_SHOP_CITIES";

const GetShopCitiesSymbols = {
  GET_SHOP_CITIES_SUCCESS,
  GET_SHOP_CITIES_FAILURE,
  GET_SHOP_CITIES,
  CLEAR_SHOP_CITIES,
};

export default GetShopCitiesSymbols;
